export const interval = 1000

export const getStarted = [
  {
    title: 'step_1',
    items: [
      { title: 'step_1_item_1_title' },
      { title: 'step_1_item_2_title', description: 'step_1_item_2_desc', src: 'getstarted_navigate.gif' },
      { title: 'step_1_item_3_title', description: 'step_1_item_3_desc', src: 'getstarted_submenu.gif' }
    ]
  },
  {
    title: 'step_2',
    items: [
      { title: 'step_2_item_1_title' },
      { title: 'step_2_item_2_title', description: 'step_2_item_2_desc', src: 'getstarted_pages.gif' },
      { title: 'step_2_item_3_title', description: 'step_2_item_3_desc', src: 'getstarted_interact.gif' }
    ]
  },
  {
    title: 'step_3',
    items: [
      { title: 'step_3_item_1_title' },
      { title: 'step_3_item_2_title', description: 'step_3_item_2_desc', src: 'getstarted_create.gif' },
      { title: 'step_3_item_3_title', description: 'step_3_item_3_desc', src: 'getstarted_editor.gif' }
    ]
  },
  {
    title: 'step_4',
    items: [
      { title: 'step_4_item_1_title' },
      { title: 'step_4_item_2_title', description: 'step_4_item_2_desc', src: 'getstarted_dashboard.gif' },
      { title: 'step_4_item_3_title', description: 'step_4_item_3_desc', src: 'getstarted_news_docs.gif' }
    ]
  },
]

export const doc = [
  { title: 'title_1', text: 'text_1', src: 'doc_mdp.gif' },
  { title: 'title_2', text: 'text_2', src: 'doc_2fa.gif' },
  { title: 'title_3', text: 'text_3', src: 'doc_dashboard.gif' },
  { title: 'title_4', text: 'text_4', src: 'doc_filters.gif' },
  { title: 'title_5', text: 'text_5', src: 'doc_export.gif' },
  { title: 'title_6', text: 'text_6', src: 'doc_newpage.gif' },
  { title: 'title_7', text: 'text_7', src: 'doc_editor.gif' },
  { title: 'title_8', text: 'text_8', src: 'doc_drawer.gif' },
  { title: 'title_9', text: 'text_9', src: 'doc_lang.gif' },
  { title: 'title_10', text: 'text_10', src: 'doc_connectapp.gif', isAdmin: true },
  { title: 'title_11', text: 'text_11', src: 'doc_editfilters.gif', isAdmin: true },
  { title: 'title_12', text: 'text_12', src: 'doc_publish.gif', isAdmin: true },
  { title: 'title_13', text: 'text_13', src: 'doc_dataaccess.gif', isAdmin: true },
  { title: 'title_14', text: 'text_14', src: 'doc_usergroups.gif', isAdmin: true },
  { title: 'title_15', text: 'text_15', src: 'doc_connectas.gif', isAdmin: true },
]